module.exports = __webpack_public_path__ + "img/increase-arrow.148a5de9.svg";